import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../../../assets/css/depoimentos.css';

const Depoimentos = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  
  const testimonials = [
    {
      id: 1,
      name: "Angélica",
      photo: "/img/depoimentos/angelica.png",
      rating: 5,
      text: "Bom dia Seu Waldir, tudo bem? Queria agradecer ter cuidado do meu piano tão bem. Muito obrigada. Vou tentar me adaptar com ele aqui em casa! Muito sucesso ai nos seus negócios e parabéns!!"
    },
    {
      id: 2,
      name: "Matheus",
      photo: "/img/depoimentos/matheus.png",
      rating: 5,
      text: "Daniel e Waldir, muito, muito, muito, muito. MUITO OBRIGADO!!! De coração mesmo!!! Eu só subi agora há pouco! Nossa, que trabalho maravilhoso vocês fizeram!!! Eu sou muito grato!!! Estou muito feliz e espero, agora, poder dedicar-me com afinco aquilo que me comprometi a fazer!! Tenho muito que agradecê-los!!!"
    },
    {
      id: 3,
      name: "Neto",
      photo: "/img/depoimentos/neto.png",
      rating: 5,
      text: "Daniel, gostaria de agradecer seu trabalho com meu piano, deu TD certo com a finalização da afinação ficou TD perfeito. Muito obrigado!"
    },
    {
      id: 4,
      name: "Rachel",
      photo: "/img/depoimentos/rachel.png",
      rating: 5,
      text: "Oi Daniel e Seu Waldir! Bom dia!! Gostaria de agradecer pela atenção de vocês! Fiquei muuuuito feliz com a surpresa! Obrigada por participarem desse momento tão especial da minha vida que é a retomada do meu sonho de infância, tocar piano e ter meu piano de causa. ❤"
    }
  ];

  const nextTestimonial = () => {
    setDirection(1);
    setCurrentIndex((prev) => 
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setDirection(-1);
    setCurrentIndex((prev) => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  // Variantes de animação
  const cardVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    },
    exit: (direction) => ({
      x: direction > 0 ? -300 : 300,
      opacity: 0,
      transition: {
        duration: 0.5
      }
    })
  };

  // Mostrar 1, 2 ou 3 cards dependendo do tamanho da tela
  const getVisibleCards = () => {
    const width = window.innerWidth;
    if (width >= 992) return 3;
    if (width >= 768) return 2;
    return 1;
  };

  const [visibleCards, setVisibleCards] = useState(getVisibleCards());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleTestimonials = [];
  for (let i = 0; i < visibleCards; i++) {
    const index = (currentIndex + i) % testimonials.length;
    visibleTestimonials.push(testimonials[index]);
  }

  return (
    <div className="depoimentos-container">
      <h2 className="depoimentos-title">O que dizem nossos clientes</h2>
      
      {/* Selo Google Top Rated */}
      <motion.div 
        className="google-badge"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <img 
          src="/img/logo_google.webp" 
          alt="Google" 
          className="google-logo" 
          loading="lazy"
        />
        <div className="top-rated-badge">
          <FaStar className="star-icon" />
          Reforma de Pianos
        </div>
      </motion.div>

      <div className="depoimentos-slider">
        <div className="depoimentos-track">
          <AnimatePresence custom={direction} initial={false}>
            {visibleTestimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                className="depoimento-card"
                custom={direction}
                variants={cardVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
              >
                <div className="depoimento-content">
                  <img 
                    src={testimonial.photo} 
                    alt={testimonial.name} 
                    className="client-photo" 
                    loading="lazy"
                  />
                  <div className="rating-stars">
                    {[...Array(5)].map((_, i) => (
                      <FaStar 
                        key={i} 
                        className="star-icon" 
                        style={{ opacity: i < testimonial.rating ? 1 : 0.3 }}
                      />
                    ))}
                  </div>
                  <h3 className="client-name">{testimonial.name}</h3>
                  <p className="client-testimonial">{testimonial.text}</p>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>

      <div className="slider-controls">
        <button 
          className="control-button"
          onClick={prevTestimonial}
          aria-label="Depoimento anterior"
        >
          <FaChevronLeft />
        </button>
        <button 
          className="control-button"
          onClick={nextTestimonial}
          aria-label="Próximo depoimento"
        >
          <FaChevronRight />
        </button>
      </div>

      <div className="slider-pagination">
        {testimonials.slice(0, Math.ceil(testimonials.length / visibleCards)).map((_, index) => (
          <button
            key={index}
            className={`pagination-dot ${Math.floor(currentIndex / visibleCards) === index ? 'active' : ''}`}
            onClick={() => goToTestimonial(index * visibleCards)}
            aria-label={`Ir para depoimento ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Depoimentos;